import React from 'react';
import { Box, Typography, Link } from '@mui/material';

export const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: { xs: 4, sm: 6 },
        px: { xs: 2, sm: 3 },
        backgroundColor: 'rgba(248, 248, 248, 0.95)',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
      }}
    >
      <Box maxWidth="md" mx="auto">
        {/* Layout centrado y minimalista */}
        <Box
          sx={{
            textAlign: 'center',
            mb: 3,
          }}
        >
          {/* Logo/Marca */}
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 700,
              color: 'primary.main',
              mb: 2,
              fontSize: '1.125rem',
              letterSpacing: '-0.01em',
            }}
          >
            CobroLink
          </Typography>

          {/* Descripción */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mb: 3,
              maxWidth: 280,
              mx: 'auto',
              lineHeight: 1.5,
            }}
          >
            Agente de cobranza simple y seguro para tus facturas.
          </Typography>

          {/* Enlaces legales */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 3,
              mb: 3,
              flexWrap: 'wrap',
            }}
          >
            <Link
              href="/privacy"
              variant="body2"
              color="text.secondary"
              underline="hover"
              sx={{
                fontSize: '0.875rem',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              variant="body2"
              color="text.secondary"
              underline="hover"
              sx={{
                fontSize: '0.875rem',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Terms of Service
            </Link>
            <Link
              href="/support"
              variant="body2"
              color="text.secondary"
              underline="hover"
              sx={{
                fontSize: '0.875rem',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Support
            </Link>
          </Box>
        </Box>

        {/* Copyright */}
        <Box
          sx={{
            pt: 3,
            borderTop: '1px solid rgba(0, 0, 0, 0.05)',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              opacity: 0.7,
            }}
          >
            © 2025 CobroLink. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
